/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eisubscaleinfluenceweak3Inputs */



/**
* | output |
* | --- |
* | "Shaping the emotional atmosphere around you can be hard — attention to other people's reactions will make conversations more comfortable." |
*
* @param {Eisubscaleinfluenceweak3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const eisubscaleinfluenceweak3 = /** @type {((inputs?: Eisubscaleinfluenceweak3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eisubscaleinfluenceweak3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Shaping the emotional atmosphere around you can be hard — attention to other people's reactions will make conversations more comfortable.")
	if (locale === "es") return /** @type {LocalizedString} */ ("A veces te cuesta influir en el clima emocional a tu alrededor — estar atento a las reacciones de los demás hará la comunicación más cómoda.")
	return /** @type {LocalizedString} */ ("Тебе бывает сложно влиять на эмоциональную атмосферу вокруг — внимательность к реакциям других поможет сделать общение более комфортным.")
});
export { eisubscaleinfluenceweak3 as "eiSubscaleInfluenceWeak" }